const IconCoupDeCoeur = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		{...props}
	>
		<path
			d="M7.74279 14.0958C7.90099 14.1906 8.09885 14.1906 8.25705 14.0958C8.44399 13.9758 9.00905 13.6131 9.32739 13.3913C9.96319 12.9483 10.8136 12.3155 11.6659 11.5567C12.5161 10.7998 13.3818 9.90584 14.0383 8.94017C14.6917 7.97904 15.1666 6.90437 15.1666 5.79627C15.1665 3.63472 13.5655 1.83337 11.3333 1.83337C10.2721 1.83337 9.24405 2.17516 7.99992 3.30993C6.75579 2.17516 5.72781 1.83337 4.66659 1.83337C2.43429 1.83337 0.833285 3.63472 0.833252 5.79627C0.833252 6.90437 1.30809 7.97904 1.96151 8.94017C2.61809 9.90584 3.4837 10.7998 4.33391 11.5567C5.18623 12.3155 6.03662 12.9483 6.67245 13.3913C6.99079 13.6131 7.55585 13.9758 7.74279 14.0958Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconCoupDeCoeur;
